// Error
export * from "./error.component";



// WEBPACK FOOTER //
// ./src/app/components/error/index.ts